import FleetCoach from "../../../views/FleetCoach";
import FleetCoachV2 from "../../../views/FleetCoachV2";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const FleetCoachRoutes = [
  {
    menuName: MenuNames.FLEET_COACH,
    path: "/fleet-coach",
    component: FleetCoach,
    exact: true,
  },
  {
    menuName: MenuNames.FLEET_COACH,
    path: "/fleet-coach/:id",
    component: FleetCoach,
    exact: true,
  },
  {
    menuName: MenuNames.FLEET_COACH_V2,
    path: "/v2/fleet-coach",
    component: FleetCoachV2,
    exact: true,
  },
  {
    menuName: MenuNames.FLEET_COACH_V2,
    path: "/v2/fleet-coach/:id",
    component: FleetCoachV2,
    exact: true,
  },
];

export default FleetCoachRoutes;
